import { calculateScoreAndIndexes } from "../../../utils/pteReorderParagraphScoring";

export { calculateScoreAndIndexes };

export const getScore = (questions, answers, option = 1) => {
  if (option === 1) {
    let score = 0;
    for (let i = 0; i < questions.length; i++) {
      if (questions[i] !== undefined && answers[i] !== undefined) {
        if (
          typeof questions[i] === "string" &&
          typeof answers[i] === "string" &&
          questions[i].toLowerCase() === answers[i].toLowerCase()
        ) {
          score++;
        } else if (questions[i] === answers[i]) {
          score++;
        }
      }
    }
    return score;
  } else if (option === 2) {
    let score = 0;
    questions.forEach((correctAnswer) => {
      const isCorrect = answers.includes(correctAnswer);
      if (isCorrect) {
        score += 1;
      }
    });
    answers.forEach((answer) => {
      const isCorrect = questions.includes(answer);
      if (!isCorrect) {
        score = Math.max(0, score - 1);
      }
    });
    return score;
  }
};
